import { Link } from "react-router-dom";
import { siteInfo } from "@/mocks/site";

export default function SubmitCta() {
  return (
    <section className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="relative overflow-hidden rounded-lg border border-background-300">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Abstract%20editorial%20photograph%20of%20a%20warm%20amber%20light%20sweeping%20across%20a%20dark%20charcoal%20surface%20with%20soft%20geometric%20shadows%2C%20minimal%20premium%20texture%2C%20cinematic%20mood%2C%20no%20text%2C%20high%20detail&width=1600&height=500&seq=cta-desk-01&orientation=landscape"
              alt="温暖的琥珀色光线掠过深色背景，象征线索被照亮"
              title="提交求证线索 · 棱镜求证"
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/95 via-foreground-950/85 to-foreground-950/60" aria-hidden="true" />

          <div className="relative grid grid-cols-1 items-center gap-6 px-6 py-10 md:grid-cols-12 md:px-10 md:py-14">
            <div className="md:col-span-8">
              <h2 className="font-heading text-2xl font-bold text-background-50 md:text-3xl">
                看到了拿不准的爆料？把线索交给我们
              </h2>
              <p className="mt-3 max-w-2xl text-sm leading-relaxed text-background-300">
                附上原始链接或截图来源，我们会按统一流程做初步核验，并在有进展时更新到案例库。
                如果你发现已有内容存在错误，也欢迎指出。
              </p>
              <div className="mt-5 flex flex-wrap items-center gap-x-6 gap-y-2 text-sm text-background-300">
                <span className="flex items-center gap-2">
                  <i className="ri-mail-line text-base text-accent-400" aria-hidden="true" />
                  {siteInfo.email}
                </span>
                <span className="flex items-center gap-2">
                  <i className="ri-timer-line text-base text-accent-400" aria-hidden="true" />
                  {siteInfo.responseTime}
                </span>
              </div>
            </div>
            <div className="md:col-span-4 md:text-right">
              <Link
                to="/about#contact"
                className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-accent-500 px-6 py-3.5 text-sm font-semibold text-foreground-950 transition-colors hover:bg-accent-400 md:w-auto"
              >
                <i className="ri-send-plane-line text-base" aria-hidden="true" />
                <span className="whitespace-nowrap">提交线索 / 联系我们</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}